/*
 * Trafford Editorial scroll animation.
 * Recreates the live Webflow "scrolling in view" interaction: as the section
 * passes through the viewport, the tall image scales down while the wide detail
 * image scales up (counter-motion), scrubbed to scroll. Webflow's literal values
 * are 1.1<->1.0; nudged to 1.15 here so the motion actually reads on screen.
 * Requires GSAP + ScrollTrigger (loaded in theme.liquid). No-op without them,
 * or when the visitor prefers reduced motion.
 */
(function () {
  function setupSection(section) {
    if (section.dataset.tEditorialInit === '1') return;
    var tall = section.querySelector('.trafford-editorial__tall .trafford-editorial__img');
    var wide = section.querySelector('.trafford-editorial__wide .trafford-editorial__img');
    if (!tall || !wide) return;

    var tl = window.gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top bottom', // section top enters viewport bottom
        end: 'bottom top', // section bottom leaves viewport top
        scrub: 1, // ~1s catch-up smoothing so the motion is legible
        invalidateOnRefresh: true // recompute distances on resize/refresh
      }
    });
    tl.fromTo(tall, { scale: 1.15 }, { scale: 1, ease: 'none' }, 0)
      .fromTo(wide, { scale: 1 }, { scale: 1.15, ease: 'none' }, 0);

    section.dataset.tEditorialInit = '1';
  }

  // Core Feature collage: same scroll-scrubbed counter-scale, adapted to 3 images.
  // Main + bottom scale down, top scales up (2 one way, 1 the other).
  function setupCollage(collage) {
    if (collage.dataset.tCollageInit === '1') return;
    var main = collage.querySelector('.trafford-core__cell--main .trafford-core__img');
    var top = collage.querySelector('.trafford-core__cell--top .trafford-core__img');
    var bottom = collage.querySelector('.trafford-core__cell--bottom .trafford-core__img');
    if (!main && !top && !bottom) return;
    var tl = window.gsap.timeline({
      scrollTrigger: { trigger: collage, start: 'top bottom', end: 'bottom top', scrub: 1, invalidateOnRefresh: true }
    });
    if (main) tl.fromTo(main, { scale: 1.12 }, { scale: 1, ease: 'none' }, 0);
    if (bottom) tl.fromTo(bottom, { scale: 1.12 }, { scale: 1, ease: 'none' }, 0);
    if (top) tl.fromTo(top, { scale: 1 }, { scale: 1.12, ease: 'none' }, 0);
    collage.dataset.tCollageInit = '1';
  }

  // Special edition blocks (Moontower, Capitol, Violet Crown): the same counter-scale on
  // their tall + wide lifestyle images, so they move like the collection blocks around them.
  function setupSpecial(block) {
    if (block.dataset.tSeInit === '1') return;
    var tall = block.querySelector('.trafford-se__tall .trafford-se__life-img');
    var wide = block.querySelector('.trafford-se__wide .trafford-se__life-img');
    if (!tall && !wide) return;
    var tl = window.gsap.timeline({
      scrollTrigger: { trigger: block, start: 'top bottom', end: 'bottom top', scrub: 1, invalidateOnRefresh: true }
    });
    if (tall) tl.fromTo(tall, { scale: 1.15 }, { scale: 1, ease: 'none' }, 0);
    if (wide) tl.fromTo(wide, { scale: 1 }, { scale: 1.15, ease: 'none' }, 0);
    block.dataset.tSeInit = '1';
  }

  // Animations misbehave in the Shopify theme editor's iframe (broken scroll
  // context). Skip entirely in design mode so the editor lays out cleanly.
  function inEditor() {
    return window.Shopify && window.Shopify.designMode;
  }

  function init(root) {
    if (inEditor()) return;
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    (root || document).querySelectorAll('.trafford-editorial').forEach(setupSection);
    (root || document).querySelectorAll('.trafford-core__collage').forEach(setupCollage);
    (root || document).querySelectorAll('.trafford-se').forEach(setupSpecial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Images change layout height after they load; recompute trigger positions
  // once everything has loaded so the section does not snap on refresh.
  window.addEventListener('load', function () {
    if (!inEditor() && window.ScrollTrigger) window.ScrollTrigger.refresh();
  });

  // Theme editor: re-init + recompute when a section is added/reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    if (!inEditor() && window.ScrollTrigger) window.ScrollTrigger.refresh();
  });
})();
